import { Component, HostBinding, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { VideoPlayerConfigService } from "@pcp/streaming";

@Component({
    selector: 'pcp-slide-sync-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    imports: [],
})
export class ToolbarComponent {
    // vertical for PCP; horizontal for Wendel
    @Input() direction: 'horizontal' | 'vertical' = 'vertical';

    @HostBinding('class.horizontal') get isHorizontal() {
        return this.direction === 'horizontal';
    }
    @HostBinding('class.vertical') get isVertical() {
        return this.direction === 'vertical';
    }

    isBugReportOn: boolean = false;

    readonly emitVideoChanges$ = this.videoConfig.emitVideoChanges$;

    constructor(
        private readonly store: Store,
        private readonly videoConfig: VideoPlayerConfigService
    ) {}

    setVideoControlEnabled(enabled: boolean) {
        this.videoConfig.setEmitVideoChanges(enabled);
    }
}
